import common from '../common';
import Scene from './Scene';
import ComicScene from '../ComicScene';
import DrawingSpine from '../drawing/DrawingSpine';
import Drawing from '../drawing/Drawing';
import ConfirmDialog from '../ConfirmDialog';
import {translate} from '../utils';

export default class SelectScene extends Scene {
	constructor() {
		super();

		this._muteButton = null;
		this.btnLeftScene = null;
		this.btnRightScene = null;
		this.btnDelete = null;
		this.btnPrint = null;
		this.btnDelete = null;
		this.btnBack = null;

		this.paginator = null;
		this.pageIcons = null;

		this._pointerdown = false;
		this._pointermoved = false;
		this._prevPoint = null;

		this.comics = [];
		this.comicContainer = null;
		this.currentIndex = 0;

		this._drawing = null;
		this.numComics = 8;

		this.dialog = null;

		this._CMF = null;
		this._menuMusic = null;
	}

	init() {
		super.init();

		this._CMF = new PIXI.filters.ColorMatrixFilter();
		this._CMF.desaturate();

		this._drawing = new Drawing();
		this._drawing.init();
		this.addChild(this._drawing);

		let bg = new PIXI.Sprite(P3.assets.texture('bg_levelselect'));
		bg.anchor.set(0.5);
		bg.position.set(common.STAGE_WIDTH * 0.5, common.STAGE_HEIGHT * 0.5);
		this.addChild(bg);

		this.comicContainer = new PIXI.Container();
		this.addChild(this.comicContainer);

		this._createCarousel();

		this.createPaginations(this.numComics);

		let states = new P3.ButtonStates();
		states.normal = P3.assets.texture('btn_pri_small_out');
		states.over = P3.assets.texture('btn_pri_small_over');
		states.down = P3.assets.texture('btn_pri_small_down');
		states.icon = P3.assets.texture('icon_pri_sound_out');
		states.iconAlt = P3.assets.texture('icon_pri_mute_out');
		this._muteButton = new P3.MuteButton(states);
		this.addChild(this._muteButton);

		states = new P3.ButtonStates();
		states.normal = P3.assets.texture('btn_ter_left_out');
		states.over = P3.assets.texture('btn_ter_left_over');
		states.down = P3.assets.texture('btn_ter_left_down');
		states.icon = P3.assets.texture('icon_ter_left_out');

		this.btnLeftScene = new P3.Button(states);
		this.btnLeftScene.animate = false;
		this.btnLeftScene.visible = false;
		this.btnLeftScene.signals.click.add(this.onBtnLeftSceneClick, this);
		this.addChild(this.btnLeftScene);

		states = new P3.ButtonStates();
		states.normal = P3.assets.texture('btn_ter_right_out');
		states.over = P3.assets.texture('btn_ter_right_over');
		states.down = P3.assets.texture('btn_ter_right_down');
		states.icon = P3.assets.texture('icon_ter_right_out');

		this.btnRightScene = new P3.Button(states);
		this.btnRightScene.animate = false;
		this.btnRightScene.signals.click.add(this.onBtnRightSceneClick, this);
		this.addChild(this.btnRightScene);

		states = new P3.ButtonStates();
		states.normal = P3.assets.texture('btn_pri_small_out');
		states.over = P3.assets.texture('btn_pri_small_over');
		states.down = P3.assets.texture('btn_pri_small_down');
		states.icon = P3.assets.texture('icon_pri_download_out');

		this.btnPrint = new P3.Button(states);
		this.btnPrint.animate = false;
		this.btnPrint.position.set(470, 630);
		this.btnPrint.signals.click.add(this.onDownloadClick, this);
		this.addChild(this.btnPrint);

		states = new P3.ButtonStates();
		states.normal = P3.assets.texture('btn_pri_small_out');
		states.over = P3.assets.texture('btn_pri_small_over');
		states.down = P3.assets.texture('btn_pri_small_down');
		states.icon = P3.assets.texture('icon_pri_replay_out');

		this.btnDelete = new P3.Button(states);
		this.btnDelete.animate = false;
		this.btnDelete.position.set(570, 630);
		this.btnDelete.signals.click.add(this.onDeleteClick, this);
		this.addChild(this.btnDelete);

		states = new P3.ButtonStates();
		states.normal = P3.assets.texture('btn_pri_small_out');
		states.over = P3.assets.texture('btn_pri_small_over');
		states.down = P3.assets.texture('btn_pri_small_down');
		states.icon = P3.assets.texture('icon_pri_back_out');

		this.btnBack = new P3.Button(states);
		this.btnBack.animate = false;
		this.btnBack.signals.click.add(() => {
			this.signals.previous.dispatch();
		}, this);
		this.addChild(this.btnBack);

		this.interactive = true;

		this.on('pointerdown', this.onPointerDown);
		this.on('pointermove', this.onPointerMove);
		this.on('pointerup', this.onPointerUp);

		if (this.comics[this.currentIndex].hasDrawnSpines) {
			this.btnPrint.filters = this.btnDelete.filters = null;
			this.btnPrint.enabled = this.btnDelete.enabled = true;
		} else {
			this.btnPrint.filters = this.btnDelete.filters = [this._CMF];
			this.btnPrint.enabled = this.btnDelete.enabled = false;
		}

		this.dialog = new ConfirmDialog(translate('delete_confirm'));
		this.dialog.position.set(common.STAGE_WIDTH * 0.5, common.STAGE_HEIGHT * 0.5 - 200);
		this.dialog.visible = false;
		this.addChild(this.dialog);

		this.comics[0].visible = false;
		this.comics[common.selectedComic].visible = true;
		this.comicContainer.x = -(this.comics[common.selectedComic].x);
		if (this.comics[this.currentIndex].hasDrawnSpines) {
			this.btnPrint.filters = this.btnDelete.filters = null;
			this.btnPrint.enabled = this.btnDelete.enabled = true;
		} else {
			this.btnPrint.filters = this.btnDelete.filters = [this._CMF];
			this.btnPrint.enabled = this.btnDelete.enabled = false;
		}
		this.setPageIcon(true);
	}

	_createCarousel() {
		this._createComics();
	}

	scrollLeft() {
		if (this.currentIndex <= 0) return;
		this.scrollTween(-1, -1);
	}

	scrollRight() {
		if (this.currentIndex >= this.comics.length - 1) return;
		this.scrollTween(-1, 1);
	}

	scrollTween(to = -1, dir) {
		this.currentIndex += dir;
		this.currentIndex = to > -1 ? to : this.currentIndex;
		new P3.utils.TWEEN.Tween(this.comicContainer, this.tweens)
			.to({
				x: -(this.comics[this.currentIndex].x)
			}, 400)
			.easing(P3.utils.TWEEN.Easing.Back.Out)
			.onStart(() => {
				this.comics[this.currentIndex] && (this.comics[this.currentIndex].visible = true);
				if (this.comics[this.currentIndex].hasDrawnSpines) {
					this.btnPrint.filters = this.btnDelete.filters = null;
					this.btnPrint.enabled = this.btnDelete.enabled = true;
				} else {
					this.btnPrint.filters = this.btnDelete.filters = [this._CMF];
					this.btnPrint.enabled = this.btnDelete.enabled = false;
				}
			})
			.onComplete(() => {
				this.comics[this.currentIndex + (dir * -1)] && (this.comics[this.currentIndex + (dir * -1)].visible = false);
			})
			.start();
	}

	_createComics() {
		for (let i = 0; i < this.numComics; i++) {
			let comic = new ComicScene('comic' + i);
			comic.signals.select.add(() => {
				this.onSelectDrawing();
			});
			comic.position.set(i * comic.width + i * 500, 0);
			this.comicContainer.addChild(comic);
			i !== 0 && (comic.visible = false);
			this.comics.push(comic);
		}
	}

	onDownloadClick() {
		const comic = this.comics[this.currentIndex];

		const canvas = common.renderer.extract.canvas(comic);
		if (!PIXI.utils.isMobile.apple.device) {
			canvas.toBlob((blob) => {
				let a = document.createElement('a');
				document.body.append(a);
				a.download = 'LearnToDraw_' + new Date().toDateString();
				a.href = URL.createObjectURL(blob);
				a.click();
				a.remove();
			}, 'image/png');
		} else {
			const imageURL = canvas.toDataURL('image/png');//.replace('image/png', 'image/octet-stream');
			const tab = window.open(imageURL, '_blank');
			tab.focus();
		}
	}

	destroy() {
		super.destroy();
		P3.audio.stopMusic();
		this._drawing.destroy();
		for (const c of this.comics)
			c.destroy();
	}

	onPointerDown() {
		this._pointermoved = false;
	}

	onPointerMove(event) {
		if (!this._pointermoved) {
			this._prevPoint = event.data.global.x;
			this._pointermoved = true;
		}
	}

	appear() {
		super.appear();
		this._menuMusic = P3.audio.playMusic('music_menu_loop_00');
	}

	onDeleteClick() {
		if (this.dialog.visible) return;
		this.dialog.visible = true;

		this.dialog.signals.confirm.add(() => {
			this._dialogOpen = false;
			this.dialog.visible = false;
			this.btnPrint.filters = this.btnDelete.filters = [this._CMF];
			this.btnPrint.enabled = this.btnDelete.enabled = false;

			const index = this.currentIndex;
			const spines = this.comics[index].spines;

			const length = spines.length;
			for (let i = 0; i < length; i++) {
				if (spines[i] instanceof DrawingSpine)
					common.saveData.saveSpineHacks(spines[i].name, {});
			}

			this.comicContainer.removeChild(this.comics[index]);
			this.comics[index].destroy();

			let comic = new ComicScene('comic' + index);
			comic.signals.select.add(() => {
				this.onSelectDrawing();
			});
			comic.position.set(index * comic.width + index * 500, 0);
			this.comicContainer.addChild(comic);
			this.comics.splice(index, 1, comic);
		}, this);
		this.dialog.signals.deny.add(() => {
			this.dialog.visible = false;
		});
	}

	onPointerUp(event) {
		if (this._pointermoved) {
			const dist = this._prevPoint - event.data.global.x;// only scroll if we're above a certain distance, to prevent accidental swipes when pressing buttons
			if (dist > 20) {
				P3.audio.playSound('sfx_btn_ui_next_drawing_00');
				this.scrollRight();
			} else if (dist < -20) {
				P3.audio.playSound('sfx_btn_ui_prev_drawing_00');
				this.scrollLeft();
			}
			this.setPageIcon(false);
		}
		this._pointerdown = false;
	}

	update() {
		super.update();
		this.comics[this.currentIndex].update();
	}

	resize() {
		super.resize();
		this._drawing.resize();

		this.btnLeftScene.position.set((common.STAGE_WIDTH - P3.View.width) * 0.5 + this.btnLeftScene.width * 0.5, common.STAGE_HEIGHT * 0.5);
		this.btnRightScene.position.set((common.STAGE_WIDTH + P3.View.width) * 0.5 - this.btnRightScene.width * 0.5, common.STAGE_HEIGHT * 0.5);
		this.btnBack.position.set((common.STAGE_WIDTH - P3.View.width) * 0.5 + 100, 100);
		this._muteButton.position.set((common.STAGE_WIDTH + P3.View.width) * 0.5 - 100, 100);
	}

	onSelectDrawing() {
		common.selectedComic = this.currentIndex;
		this.signals.next.dispatch(this);
	}

	onBtnLeftSceneClick() {
		P3.audio.playSound('sfx_btn_ui_prev_drawing_00');
		this.scrollLeft();
		this.setPageIcon(false);
	}

	onBtnRightSceneClick() {
		P3.audio.playSound('sfx_btn_ui_next_drawing_00');
		this.scrollRight();
		this.setPageIcon(false);
	}

	setPageIcon(to = false) {
		this.currentIndex = to ? common.selectedComic : this.currentIndex;
		for (let i = 0; i < this.pageIcons.children.length; i++) {
			this.pageIcons.children[i].texture = P3.assets.texture('pagination_off');
			if (i === this.currentIndex)
				this.pageIcons.children[i].texture = P3.assets.texture('pagination_on');
		}

		if (this.currentIndex === 0) {
			this.btnLeftScene.visible = false;
			this.btnRightScene.visible = true;
		} else if (this.currentIndex === this.numComics - 1) {
			this.btnLeftScene.visible = true;
			this.btnRightScene.visible = false;
		} else
			this.btnLeftScene.visible = this.btnRightScene.visible = true;
	}

	createPaginations(count) {
		this.paginator = new PIXI.Container();
		this.addChild(this.paginator);

		let pagePanel = new PIXI.Sprite(P3.assets.texture('pagination'));
		pagePanel.anchor.set(0.5);
		this.paginator.addChild(pagePanel);

		this.pageIcons = new PIXI.Container();
		this.pageIcons.position.set(-this.paginator.width * 0.5 + 50, 0);
		this.paginator.addChild(this.pageIcons);

		for (let i = 0; i < count; i++) {
			let icon = new PIXI.Sprite(P3.assets.texture('pagination_off'));
			icon.anchor.set(0.5);
			icon.position.set(i * (this.paginator.width - 40) / count, 0);
			icon.index = i;
			icon.interactive = true;
			icon.buttonMode = true;
			icon.on('pointertap', () => {
				if (icon.index > this.currentIndex)
					P3.audio.playSound('sfx_btn_ui_next_drawing_00');
				 else
					P3.audio.playSound('sfx_btn_ui_prev_drawing_00');

				this.scrollTween(icon.index);
				this.setPageIcon();
			});
			this.pageIcons.addChild(icon);
		}

		this.paginator.position.set(common.STAGE_WIDTH * 0.5, common.STAGE_HEIGHT - this.paginator.height * 0.5);
		this.pageIcons.children[0].texture = P3.assets.texture('pagination_on');
	}
}
